export default function (element, data) {
    window.addEventListener("open-mobile-menu", function () {
        element.classList.add("open");
        document.body.classList.add('no-scroll');
    });

    window.addEventListener("close-mobile-menu", function () {
        element.classList.remove("open");
        document.body.classList.remove('no-scroll');
    });

    element.addEventListener("click", function (event) {
        window.dispatchEvent(new CustomEvent('close-mobile-menu'));
    });
    element.querySelector(".mobile__menu_block").addEventListener("click", function (event) {
        event.stopPropagation();
    });
};